import React, { useState } from "react";
import { Box, Typography } from "@mui/material";
import LaunchIcon from "@mui/icons-material/Launch";
import CompanySetupCard from "../../Components/CompanySetupCard/CompanySetupCard";
import QuickBooks from "../../assets/logo/Quickbooks.svg";
import Xero from "../../assets/logo/Xero.svg";

function AccountSoftware({ onBack }) {
	const accountingSoftware = [
		{
			id: "Xero",
			name: "Xero",
			logo: Xero,
			body: `A cloud-based accounting platform that simplifies financial
      management with real-time insights and streamlined
      bookkeeping.`,
			buttonText: "Access Discount",
			applicationUrl:
				"https://xero5440.partnerlinks.io/xero-discounted-pricing-plans",
			offer: "50% discount for the first 3 months",
		},
		{
			id: "QuickBooks",
			name: "QuickBooks",
			logo: QuickBooks,
			body: `An intuitive accounting solution offering invoicing, expense
      tracking, and financial reporting to help businesses
      effectively manage finances.`,
			buttonText: "Access Discount",
			applicationUrl:
				"https://quickbooks.partnerlinks.io/qb-discounted-pricing-plans",
			offer: " Offer: 50% discount for the first month",
		},
	];

	const handleOpenAccount = () => {};
	return (
		<Box sx={{ p: 3, width: "100%", bgcolor: "#fff" }}>
			{/* Header Section */}
			<Box
				sx={{
					display: "flex",
					justifyContent: "space-between",
					alignItems: "center",
					mb: 3,
				}}>
				<Typography
					variant='body1'
					sx={{ mb: 3, fontWeight: "500", color: "black" }}>
					Congratulations, you have now incorporated (Company Name)!
				</Typography>
			</Box>

			{/* Description Text */}

			{accountingSoftware.map((val) => (
				<CompanySetupCard
					id={val.id}
					logo={val.logo}
					title={val.name}
					offer={val.offer || ""}
					body={val.body}
					icon={LaunchIcon}
					buttonText={val.buttonText}
					applicationUrl={val.applicationUrl}
					handleOpenAccount={handleOpenAccount}
				/>
			))}
		</Box>
	);
}

export default AccountSoftware;
